import { createInertiaApp } from '@inertiajs/react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import type { ReactNode } from 'react';

import '../css/app.css';
import { initSentry } from './lib/sentry';

initSentry();

const appName = import.meta.env['VITE_APP_NAME'] ?? 'injury-lawyer.help';

void createInertiaApp({
    title: (title) => title || appName,
    resolve: (name) => {
        const pages = import.meta.glob<{ default: () => ReactNode }>(
            './Pages/**/*.tsx',
            { eager: true },
        );
        const page = pages[`./Pages/${name}.tsx`];
        if (!page) {
            throw new Error(`Inertia page not found: ${name}`);
        }
        return page;
    },
    setup({ el, App, props }) {
        if (el.hasChildNodes()) {
            hydrateRoot(el, <App {...props} />);
        } else {
            createRoot(el).render(<App {...props} />);
        }
    },
    progress: {
        color: '#B5482A',
    },
});
